import { useFormContext } from 'react-hook-form';
import { FILTER_SECTIONS, Filter } from '@anytag/shared-molecules';
import {
  AgeField,
  FollowerField,
  PostPriceField,
  SocialMediasField,
  CampaignJoinedField,
  CampaignDisplayField,
  RegionAndProvinceField,
  InfluencerCategoryField,
  InfluencerStatusesField,
  TalentAgencyPartnerField,
  EngagementFollowersAndViewsRateField
} from '../../shared';
import { AdvancedFilterDefaultProps } from '../../schemaTypes';
import { defaultAllInfluencersFormValues, AllInfluencersFilterFormValues } from '../schemaTypes';

export const AdvancedFilter = ({ count, onSubmit, isEngagementPage }: AdvancedFilterDefaultProps) => {
  const { reset, getValues } = useFormContext<AllInfluencersFilterFormValues>();

  const values = getValues();

  const handleClear = () => {
    reset({
      ...defaultAllInfluencersFormValues,
      // Basic filter
      keyword: values.keyword,
      genders: values.genders,
      countryIds: values.countryIds
    });
  };

  return (
    <Filter.MoreFilterPopover
      count={count}
      onClear={handleClear}
      onSubmit={onSubmit}
      items={[
        {
          value: FILTER_SECTIONS.InfluencerAttributes,
          title: FILTER_SECTIONS.InfluencerAttributes,
          node: (
            <>
              <AgeField hideSlider />
              <InfluencerStatusesField />
              <SocialMediasField />
              <TalentAgencyPartnerField />
              <InfluencerCategoryField />
              <RegionAndProvinceField />
              {!isEngagementPage ? <CampaignDisplayField /> : null}
            </>
          )
        },
        {
          value: FILTER_SECTIONS.PerformanceFilter,
          title: FILTER_SECTIONS.PerformanceFilter,
          node: (
            <>
              <FollowerField />
              <CampaignJoinedField />
              <EngagementFollowersAndViewsRateField />
              <PostPriceField />
            </>
          )
        }
      ]}
    />
  );
};
